import { Component, ChangeDetectorRef } from '@angular/core';

import { StorageService } from '@core/services/util/storage.service';
import { LoginService } from '@core/services/login/login.service';
import { ToastrService } from '@core/services/notification/toastr.service';
import { UtilityService } from '@core/services/util/utility.service';
import { CustomerService } from '@core/services/customer/customer.service';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { SentryBreadcrumbsService } from '@app/core/services/sentry-breadcrumbs.service';

@Component({
    selector: 'app-login-base',
    template: '',
    standalone: true
})
export class LoginBaseComponent {
    btnLoading = false;

    constructor(
        public storageService: StorageService,
        public loginService: LoginService,
        public toastrService: ToastrService,
        public utilityService: UtilityService,
        public customerService: CustomerService,
        public authenticationService: AuthenticationService,
        public cdr: ChangeDetectorRef,
        public breadCrumb: SentryBreadcrumbsService
    ) {}

    initiateResetPassword() {
        this.btnLoading = true;

        this.loginService
            .initiateResetPassword()
            .toPromise()
            .then((data: any) => {
                if (data.meta.code === 200) {
                    this.authenticationService.nextStep('forgot-password');
                } else {
                    this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                }
            })
            .catch((e) => {
                this.errorHandler(e);
            })
            .finally(() => {
                this.btnLoading = false;
                this.cdr.markForCheck();
            });
    }

    generateOtp(login_method: string) {
        this.loginService.ensureSessionId().then(() => {
            this.loginService
                .generateOtp(login_method)
                .toPromise()
                .then((data: any) => {
                    if (data && data.meta) {
                        this.authenticationService.mobileStep.next('otp-verification');
                        this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                    }
                })
                .catch((e) => {
                    this.errorHandler(e);
                });
        });
    }

    signInWithPassword(otp) {
        this.loginService.ensureSessionId().then(() => {
            this.loginService
                .signinWithPassword(otp)
                .then((data: any) => {
                    this.breadCrumb.add('auth', 'LoginBaseComponent SiginWithPassword 200', null);

                    if (data && data.meta) {
                        if (data.meta.code === 200) {
                            this.authenticationService.closeWrapperDialog.next({ authentication: true });
                            this.customerService.setAuthTokenAndFetchDetails(data);
                        } else if (data.meta.code === 201) {
                            this.authenticationService.nextStep('otp-verification');
                            this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                        } else {
                            this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                        }
                    }
                })
                .catch((e) => {
                    this.errorHandler(e);
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.cdr.markForCheck();
                });
        });
    }

    signInWithOtp(password) {
        this.loginService.ensureSessionId().then(() => {
            this.loginService
                .signinWithOtp(password)
                .toPromise()
                .then((data: any) => {
                    if (data && data.meta) {
                        if (data.meta.code === 200) {
                            this.breadCrumb.add('auth', 'LoginBaseComponent SiginWithOTP 200', null);
                            this.authenticationService.closeWrapperDialog.next({ authentication: true });
                            this.customerService.setAuthTokenAndFetchDetails(data);
                        } else {
                            this.breadCrumb.add('auth', 'LoginBaseComponent SiginWithOTP !200', null);
                            this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                        }
                    }
                })
                .catch((e) => {
                    this.errorHandler(e);
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.cdr.markForCheck();
                });
        });
    }

    errorHandler(error) {
        try {
            this.breadCrumb.add('auth', 'LoginBaseComponent SiginWithOTP/Password Error Handler', { data: error });
            const message = error.meta?.message || '';
            this.toastrService.openSnackBar(message, 'OKAY');
        } catch (e) {
            console.log(e);
        }
    }
}
